<template>
  <div class="app-spinner">
    <FontAwesomeIcon
      class="app-spinner__icon"
      :class="spinnerClasses"
      :icon="spinnerIcon"
    />
    <div class="app-spinner__slot">
      <slot/>
    </div>

  </div>
</template>

<script>
export default {
  // Name
  name: 'AppSpinner',

  // Props
  props: {
    text: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: true
    }
  },

  // Computed
  computed: {
    spinnerIcon () {
      return this.loading ? 'spinner' : 'check-circle'
    },

    spinnerClasses () {
      return {
        'app-spinner__icon--loading': this.loading,
        'app-spinner__icon--complete': !this.loading
      }
    }
  }
}
</script>

<style scoped lang="scss">
.app-spinner {
  display: flex;
  align-items: center;
  margin-top: 20px;

  @include breakpoint('tablet-portrait-up') {
    margin-top: 25px;
  }

  &__icon {
    font-size: 30px;

    @include breakpoint('tablet-portrait-up') {
      font-size: 40px;
    }

    &--loading {
      animation: spinner;
      animation-duration: 1.5s;
      animation-direction: forwards;
      animation-iteration-count: infinite;
      color: $brand-color-primary;
    }

    &--complete {
      color: #00C700;
    }
  }

  &__slot {
    margin-left: 20px;
    font-size: 11px;
    text-align: left;
    overflow: hidden;
    white-space:nowrap;
    text-overflow:ellipsis;

    @include breakpoint('tablet-portrait-up') {
      font-size: 17px;
    }
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
